var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initBundle = /* @__PURE__ */ __name(($el) => {
  const bundle_products = [...$el.querySelectorAll("[data-product-handle][data-product-id]")]?.map((element) => ({
    element,
    ..._product.getHtmlProduct(element.getAttribute("data-product-handle"))
  }));
  const sort_values = ["day", "week", "month", "year"];
  const selling_plan_options = [];
  const section_settings = utils.JSONParse($el.getAttribute("data-section-settings"));
  const limit_mode = section_settings?.limit_mode || "restrict_bundle_quantity";
  const select_settings = utils.JSONParse(
    $el.querySelector("[data-select-settings]")?.getAttribute("data-select-settings")
  );
  const select_type = select_settings?.type ?? "auto";
  const bundle_targets = [...$el.querySelectorAll("[data-bundle-target]") ?? []].map(
    (el) => utils.JSONParse(
      el.getAttribute("data-bundle-target")
    )
  );
  const initial_bundle_target_id = bundle_targets?.[0]?.id;
  const initial_target = {
    ...bundle_targets?.[0]
  };
  bundle_targets?.sort((a, b) => a.settings?.target - b?.settings?.target);
  const bundle_target_objects = bundle_targets?.reduce((acc, item, i) => {
    acc[item.id] = item.settings;
    return acc;
  }, {});
  const incentive_targets = [...$el.querySelectorAll("[data-bundle-incentive-target]") ?? []].map(
    (el) => utils.JSONParse(el.getAttribute("data-bundle-incentive-target"))
  );
  const bundle_type = section_settings.bundle_target_type;
  const addToBundle = /* @__PURE__ */ __name(({
    product,
    variant,
    price
  }) => {
    if (variant?.inventory_management && variant?.inventory_policy !== "continue") {
      const quantity_added = state.items_added.reduce((acc, item) => {
        if (item?.variant?.id === variant.id) {
          acc += 1;
        }
        return acc;
      }, 0);
      if (variant.inventory_quantity - quantity_added < 1) {
        _stores.toast.addToast({
          type: "error",
          title: "Not enough inventory",
          content: "It looks like you already added the item and the inventory limit has been reached."
        });
        return;
      }
    }
    if (limit_mode === "pack_size") {
      if (state.max_items !== null && state.items_added.length >= state.max_items) {
        _stores.toast.addToast({
          type: "warning",
          title: "Your Bundle is already complete!",
          content: "You can't add more products to this pack."
        });
        return;
      }
      state.items_added.push({ product, variant, price_override: price });
      updateBundleById();
      return;
    } else if (limit_mode === "bundle_target") {
      if (state.bundle_target?.target && state.items_added.length >= state.bundle_target.target) {
        _stores.toast.addToast({
          type: "warning",
          title: "Your Bundle is already complete!",
          content: "You can't add more products to this bundle."
        });
        return;
      }
      state.items_added.push({ product, variant, price_override: price });
      updateBundleById();
      return;
    }
    if (section_settings.restrict_bundle_quantity === "hard_limit") {
      if (state?.[bundle_type] < state.bundle_target?.target) {
        state.items_added.push({ product, variant, price_override: price });
      }
      updateBundleById();
      return;
    }
    if (section_settings.restrict_bundle_quantity === "upgrade_limit") {
      const lastBundleTarget = [...bundle_targets].sort((a, b) => a?.settings?.target - b?.settings?.target)?.at(-1);
      if (state?.[bundle_type] < lastBundleTarget?.settings?.target) {
        state.items_added.push({ product, variant, price_override: price });
      } else {
        _stores.toast.addToast({
          type: "warning",
          title: "Your Bundle is already complete!"
        });
        return;
      }
      updateBundleById();
      return;
    }
    if (section_settings.restrict_bundle_quantity === "no_limit") {
      state.items_added.push({ product, variant, price_override: price });
      updateBundleById();
      return;
    }
  }, "addToBundle");
  const removeFromBundle = /* @__PURE__ */ __name(({
    product,
    variant
  }) => {
    const index = state.items_added?.findLastIndex((item) => item?.variant?.id === variant?.id && item.product.id === product.id);
    state.items_added.splice(index, 1);
  }, "removeFromBundle");
  const state = window.Alpine.reactive({
    items_added: [],
    bundle_target_titles: [],
    item_added_summary: [],
    bundle_target_id: initial_bundle_target_id,
    total_price: 0,
    discounted_price: 0,
    current_wording: "",
    difference_wording: "",
    target_wording: "",
    final_price: 0,
    subscription_price_before_discounts: 0,
    subscription_price: 0,
    before_discounts_price: 0,
    selling_plan_discount_wording: "",
    selling_plan_discount_wording_old: "",
    target_discount_wording: "",
    active_target_discount_wording: "",
    discount_wording: "",
    active_discount_wording: "",
    item_count: 0,
    target_difference: "",
    selling_plan_options,
    selected_selling_plan: null,
    bundle_target: initial_target?.settings,
    achieved_bundle_target: null,
    incentive_target: incentive_targets?.[0],
    selling_plan_duration: "",
    isAdding: false,
    items_added_to_cart: false,
    show_mobile_details: false,
    addToBundle,
    removeFromBundle,
    selected_pack_size: null,
    max_items: null,
    pack_size_discount_percentage: 0,
    pack_size_discounts_map: {}
  });
  const getTargetTitles = /* @__PURE__ */ __name(() => {
    return bundle_targets?.map((item) => {
      const lowestPrice = Math.min(...bundle_products.map((product) => product.price_min));
      const highestPrice = Math.max(...bundle_products.map((product) => product.price_max ?? product.price));
      const priceVaries = (state?.final_price || lowestPrice) !== (state?.total_price || highestPrice);
      return item.label?.trim() ? `<span class="flex gap-2 w-full items-center">${utils.unescape(
        item.label?.replace(
          "[price]",
          `<span>${utils.formatMoney(
            state?.final_price || (lowestPrice - (item?.settings?.discount_percentage ?? 0) / 100 * lowestPrice - (item?.settings?.discount_amount ?? 0)) * (section_settings?.bundle_target_type === "item_count" ? item.settings?.target : 1)
          )}</span>`
        ).replace(
          "[compare_at_price]",
          `<span class="opacity-50 line-through">${utils.formatMoney(
            state?.total_price || lowestPrice * (section_settings?.bundle_target_type === "item_count" ? item.settings?.target : 1)
          )}</span>`
        )
      )}</span>` : `<span class="flex items-center gap-2">
       ${section_settings?.bundle_target_type === "total_price" && item.settings?.target ? `<span>Spend ${utils.formatMoney(item.settings?.target)}</span>` : ""}
       ${section_settings?.bundle_target_type === "item_count" ? `<span>${item.settings?.target} ${item.settings?.target === 1 ? "item" : "items"}</span>` : ""}
       ${item?.settings?.discount_percentage > 0 && select_settings?.discount_label?.trim() ? `<span class="${select_settings?.discount_label}">${item?.settings?.discount_percentage}% off</span>` : ""}
       ${item?.settings?.discount_amount > 0 && select_settings?.discount_label?.trim() ? `<span class="${select_settings?.discount_label}">${utils.formatMoney(
        item?.settings?.discount_percentage
      )} off</span>` : ""}
       ${select_settings?.price_content ? `<span class="flex-1 flex justify-end gap-2">
           ${select_settings?.price_content?.replace(
        "[price]",
        `<span>${utils.formatMoney(
          state?.final_price || (lowestPrice - (item?.settings?.discount_percentage ?? 0) / 100 * lowestPrice - (item?.settings?.discount_amount ?? 0)) * (section_settings?.bundle_target_type === "item_count" ? item.settings?.target : 1)
        )}</span>`
      ).replace(
        "[compare_at_price]",
        priceVaries ? `<span class="opacity-50 line-through">${utils.formatMoney(
          state?.total_price || lowestPrice * (section_settings?.bundle_target_type === "item_count" ? item.settings?.target : 1)
        )}</span>` : ""
      )}` : ""}
      </span>`?.replace(/\n/gi, "").trim();
    });
  }, "getTargetTitles");
  const packSizeSelector = $el.querySelector("[data-pack-size-selector]");
  if (packSizeSelector) {
    const sizesAttr = packSizeSelector.getAttribute("data-pack-sizes");
    const discountsAttr = packSizeSelector.getAttribute("data-pack-sizes-discounts");
    if (sizesAttr) {
      const sizes = sizesAttr.split(",").map((s) => parseInt(s.trim(), 10)).filter(Boolean).sort((a, b) => a - b);
      const discounts = discountsAttr ? discountsAttr.split(",").map((d) => d.trim()) : [];
      state.pack_size_discounts_map = sizes.reduce((acc, size, index) => {
        if (discounts[index]) {
          const match = discounts[index].match(/(\d+(?:\.\d+)?)/);
          const discountValue = match ? parseFloat(match[1]) : 0;
          acc[size] = isNaN(discountValue) ? 0 : discountValue;
        } else {
          acc[size] = 0;
        }
        return acc;
      }, {});
      if (sizes.length > 0) {
        state.selected_pack_size = sizes[0];
        state.max_items = Math.floor(sizes[0]);
        state.pack_size_discount_percentage = state.pack_size_discounts_map[sizes[0]] || 0;
      }
      window.Alpine.effect(() => {
        if (state.selected_pack_size && state.pack_size_discounts_map) {
          const discount = state.pack_size_discounts_map[state.selected_pack_size];
          if (discount !== void 0) {
            state.pack_size_discount_percentage = discount;
          }
        }
      });
    }
  }
  state.bundle_target_titles = getTargetTitles();
  window.Alpine.effect(() => {
    state.item_count = state.items_added?.length;
    state.total_price = state.items_added.reduce((acc, item) => acc += item?.price_override ?? item.variant?.price, 0);
    state.achieved_bundle_target = [...bundle_targets].sort((a, b) => b.settings?.target - a?.settings?.target)?.find((bundle) => bundle.settings.target <= state?.[bundle_type])?.settings;
    if (select_type === "auto") {
      state.bundle_target = [...bundle_targets].sort((a, b) => a.settings?.target - a?.settings?.target).find((bundle) => bundle.settings.target > state?.[bundle_type])?.settings;
    }
    let hasSellingPlan = true;
    state.selling_plan_options = (state.item_count > 0 ? state.items_added?.map(({ product, variant }) => ({ ...product, variants: [variant] })) : [])?.reduce((acc, product, i) => {
      product.variants?.forEach((variant) => {
        if (variant?.selling_plan_allocations?.length === 0) {
          hasSellingPlan = false;
        }
        variant?.selling_plan_allocations?.forEach((allocation) => {
          acc.push(allocation);
        });
      });
      return hasSellingPlan ? acc : [];
    }, []).filter((a, i, arr) => arr.findIndex((b) => b?.selling_plan?.name === a?.selling_plan?.name) === i)?.sort(
      (a, b) => sort_values.findIndex((value) => new RegExp(`${value}`, "gi").test(a.selling_plan.name)) - sort_values.findIndex((value) => new RegExp(`${value}`, "gi").test(b.selling_plan.name))
    );
    state.selling_plan_options = state?.selling_plan_options?.every((a, i, arr) => {
      if (a?.selling_plan_group_id !== arr[i - 1]?.selling_plan_group_id) return [];
      return arr;
    }) ? state.selling_plan_options : [];
    if (state.selected_selling_plan) {
      state.selected_selling_plan = state.selling_plan_options?.some(
        (item) => item.selling_plan.name === state.selected_selling_plan
      ) ? state.selected_selling_plan : selling_plan_options?.[0]?.selling_plan?.name;
    }
    if (!state.selling_plan_options?.length) {
      state.selected_selling_plan = null;
    }
    const subscription_price = state.items_added.reduce((acc, item) => {
      acc = acc + (item?.price_override ?? item.variant?.selling_plan_allocations?.find(
        (plan) => plan?.selling_plan?.name === (state.selected_selling_plan ?? state.selling_plan_options?.[0]?.selling_plan?.name)
      )?.price ?? item.variant?.price);
      return acc;
    }, 0);
    let pack_size_discount_amount = 0;
    if (limit_mode === "pack_size" && state.pack_size_discount_percentage > 0) {
      pack_size_discount_amount = Math.round(state.total_price * (state.pack_size_discount_percentage / 100));
    }
    const bundle_target_discount = (state.achieved_bundle_target?.discount_amount ?? 0) + state.total_price * ((state?.achieved_bundle_target?.discount_percentage ?? 0) / 100);
    state.discounted_price = state.total_price - bundle_target_discount - pack_size_discount_amount;
    state.subscription_price_before_discounts = subscription_price;
    const subscription_bundle_discount = (state.achieved_bundle_target?.discount_amount ?? 0) + subscription_price * ((state?.achieved_bundle_target?.discount_percentage ?? 0) / 100);
    const subscription_pack_discount = Math.round(subscription_price * (state.pack_size_discount_percentage / 100));
    state.subscription_price = subscription_price - subscription_bundle_discount - subscription_pack_discount;
    state.before_discounts_price = state.selected_selling_plan ? state.subscription_price_before_discounts : state.total_price;
    state.final_price = state.selected_selling_plan ? state.subscription_price : state.discounted_price;
    if (state.max_items !== null) {
      state.target_difference = state.max_items - state.item_count > 0 ? `${state.max_items - state.item_count}` : "";
    } else if (bundle_type === "item_count") {
      state.target_difference = state.bundle_target?.target - state.item_count > 0 ? `${state.bundle_target?.target - state.item_count}` : "";
    } else {
      state.target_difference = state.bundle_target?.target - state.total_price > 0 ? `${utils.formatMoney(state.bundle_target?.target - state.total_price)}` : "";
    }
    state.target_wording = bundle_type === "item_count" ? `${state.bundle_target?.target}` : utils.formatMoney(state.bundle_target?.target);
    state.current_wording = bundle_type === "item_count" ? `${state.item_count}` : utils.formatMoney(state.total_price);
    state.difference_wording = bundle_type === "item_count" ? `${state.bundle_target?.target - state.item_count}` : utils.formatMoney(state.bundle_target?.target - state.total_price);
    state.selling_plan_discount_wording = state.bundle_target?.discount_amount ? `Save ${utils.formatMoney(state.bundle_target?.discount_amount)}` : state?.bundle_target?.discount_percentage ? `${state?.bundle_target?.discount_percentage}% off` : "";
    state.target_discount_wording = state.bundle_target?.discount_amount ? `Save ${utils.formatMoney(state.bundle_target?.discount_amount)}` : state?.bundle_target?.discount_percentage ? `${state?.bundle_target?.discount_percentage}% off` : "";
    state.discount_wording = `${utils.roundToIndex((1 - state.final_price / state.total_price) * 100, 0)}% off`;
    state.active_target_discount_wording = state.total_price > state.final_price ? state.target_discount_wording : "";
    state.active_discount_wording = state.total_price > state.final_price ? `${state?.achieved_bundle_target?.discount_percentage}% off` : "";
    state.item_added_summary = state?.items_added?.reduce((acc, item) => {
      const addedIndex = acc.findIndex((item2) => item?.variant?.id === item2?.variant?.id);
      if (addedIndex !== -1 && item.price_override === acc[addedIndex]["price_override"]) {
        acc[addedIndex]["quantity"] += 1;
      } else {
        const selling_plan = item.variant?.selling_plan_allocations?.find(
          (plan) => plan.selling_plan?.name === state.selected_selling_plan
        );
        acc.push({
          quantity: 1,
          subscription: selling_plan?.selling_plan?.options?.at(-1)?.value,
          price: selling_plan?.price ?? item.variant?.price,
          compare_at_price: selling_plan?.compare_at_price,
          ...item
        });
      }
      return acc;
    }, []);
    state.bundle_target_titles = getTargetTitles();
  });
  const updateBundleById = /* @__PURE__ */ __name((bundle_id = state.bundle_target_id) => {
    state.bundle_target_id = bundle_id;
    if (state.bundle_target_id || state.items_added?.length) {
      state.bundle_target = bundle_targets.find((target) => {
        if (bundle_type === "item_count") {
          return target.id === state.bundle_target_id && target.settings.target >= state.items_added?.length;
        } else {
          return target.id === state.bundle_target_id;
        }
      })?.settings;
      if (!state.bundle_target && bundle_targets?.length) {
        const bundle_target = [...bundle_targets].sort((a, b) => a.settings.target - b.settings.target).find((target) => {
          if (bundle_type === "item_count") {
            return target.settings.target >= state.items_added?.length;
          } else {
            return true;
          }
        }) ?? [...bundle_targets].sort((a, b) => b.settings.target - a.settings.target)?.[0];
        state.bundle_target = bundle_target?.settings;
        state.bundle_target_id = bundle_target?.id;
      }
    }
  }, "updateBundleById");
  const setSellingPlan = /* @__PURE__ */ __name((name) => {
    state.selected_selling_plan = name;
  }, "setSellingPlan");
  const handleAddToCart = /* @__PURE__ */ __name(async (action) => {
    const p_id = utils.shortUUID();
    try {
      state.isAdding = true;
      const parentProductHandle = section_settings?.parent_product;
      let parentProduct = null;
      let parentProductVariantId = null;
      if (parentProductHandle && window._products[`${parentProductHandle}`]) {
        parentProduct = window._products[`${parentProductHandle}`];
        if (parentProduct.variants?.length) {
          parentProductVariantId = parentProduct.variants[0].id;
        }
      }
      const items = [];
      if (parentProductVariantId) {
        items.push({
          id: parentProductVariantId,
          quantity: 1,
          properties: {
            _p_id: p_id,
            Bundle: state.achieved_bundle_target?.label,
            _p_zero_price: "true",
            _p_dynamic_title: `Custom Bundle (${state.selected_pack_size} Pack)`,
            "Pack Size": `${state.selected_pack_size} Pack`
          }
        });
        state.items_added?.forEach((item) => {
          items.push({
            id: item?.variant?.id,
            properties: {
              _p_id_link: p_id,
              _p_required: "true",
              _p_fixed_quantity: "true",
              Bundle: state.achieved_bundle_target?.label
            },
            quantity: 1,
            selling_plan: item.variant?.selling_plan_allocations?.find(
              (plan) => plan?.selling_plan?.name === state.selected_selling_plan
            )?.selling_plan?.id
          });
        });
      } else {
        state.items_added?.forEach((item, index) => {
          items.push({
            id: item?.variant?.id,
            properties: {
              _p_id: index === 0 ? p_id : void 0,
              _p_id_link: index > 0 ? p_id : void 0,
              _p_required: index > 0 ? "true" : void 0,
              _p_fixed_quantity: index > 0 ? "true" : void 0,
              Bundle: state.achieved_bundle_target?.label
            },
            quantity: 1,
            selling_plan: item.variant?.selling_plan_allocations?.find(
              (plan) => plan?.selling_plan?.name === state.selected_selling_plan
            )?.selling_plan?.id
          });
        });
      }
      const data = await _cart.add({ items });
      if (data.cart_error) {
        state.isAdding = false;
        return;
      }
      if (action === "add_to_cart") {
        _stores.modal.setId("modal--cart-drawer");
      }
      if (action === "checkout") {
        document.querySelector('[data-cart-drawer-checkout-form] button[name="checkout"]')?.click();
        state.isAdding = false;
        state.items_added_to_cart = true;
        await utils.delay(3500);
        state.items_added_to_cart = false;
        return;
      }
      state.items_added = [];
      state.bundle_target_id = bundle_targets?.[0]?.id;
      state.total_price = 0;
      state.discounted_price = 0;
      state.final_price = 0;
      state.subscription_price = 0;
      state.selling_plan_discount_wording = "";
      state.discount_wording = "";
      state.item_count = 0;
      state.target_difference = "";
      state.selling_plan_options = selling_plan_options;
      state.selected_selling_plan = null;
      state.bundle_target = bundle_targets?.[0]?.settings;
      state.achieved_bundle_target = null;
      state.incentive_target = incentive_targets?.[0];
      state.selling_plan_duration = "";
      state.isAdding = false;
      state.show_mobile_details = false;
      state.items_added_to_cart = true;
      await utils.delay(3500);
      state.items_added_to_cart = false;
    } catch (error) {
      console.log(error);
    }
  }, "handleAddToCart");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicPluralizedText(content, state);
  }, "getDynamicText");
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicValueWithFallbacks = /* @__PURE__ */ __name((content) => {
    return content.split(",")?.reduce((acc, item) => {
      acc || (acc = utils.getBracketInputDynamicValue(item.trim(), state));
      return acc;
    }, "");
  }, "getDynamicValueWithFallbacks");
  const showConditionally = /* @__PURE__ */ __name((show_conditionally) => {
    if (!show_conditionally) {
      return true;
    }
    switch (show_conditionally) {
      case "opened":
        return state.show_mobile_details;
      case "closed":
        return !state.show_mobile_details;
      case "always": {
        return true;
      }
      case "active_discount": {
        return !!state.active_discount_wording;
      }
      case "no_active_discount": {
        return !state.active_discount_wording;
      }
      case "target_reached": {
        return !state.target_difference;
      }
      case "target_not_reached": {
        return !!state.target_difference;
      }
      default:
        return false;
    }
  }, "showConditionally");
  const showBasedOnBundleState = /* @__PURE__ */ __name((show_based_on_bundle_state) => {
    if (!show_based_on_bundle_state) {
      return true;
    }
    switch (show_based_on_bundle_state) {
      case "always":
        return true;
      case "bundle_empty":
        return state[bundle_type] === 0;
      case "some_items_added":
        return state[bundle_type] > 0;
      case "items_added":
        return state[bundle_type] > 0 && state[bundle_type] < state?.bundle_target?.target;
      case "bundle_complete":
        return state[bundle_type] >= state?.bundle_target?.target;
    }
  }, "showBasedOnBundleState");
  return {
    bundle: state,
    bundle_targets,
    bundle_target_objects,
    incentive_targets,
    section_settings,
    bundle_type,
    selling_plan_options,
    addToBundle,
    removeFromBundle,
    setSellingPlan,
    updateBundleById,
    handleAddToCart,
    getDynamicValue,
    getDynamicValueWithFallbacks,
    getDynamicText,
    showConditionally,
    showBasedOnBundleState
  };
}, "initBundle");
window._sections["initBundle"] = initBundle;
